import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import useColorScheme from 'hooks/useColorScheme';
import Text from './Text';
import Button from './Button';
import Spacer from './Spacer';
import { rem } from './values';
import { CardView } from './CardView';
import ContactSupportTextButton from './ContactSupportTextButton';
const lightImg = require('./img/no_connection.png');
const darkImg = require('./img/no_connection_dark.png');
const ConnectionFailed = ({ requesting, handleTryAgain, }) => {
    const colorScheme = useColorScheme();
    return (<CardView noMarginTop withPadding style={styles.cardView}>
      <View style={styles.container}>
        <View style={styles.content}>
          <Image source={colorScheme === 'dark' ? darkImg : lightImg} style={styles.img} resizeMode="cover"/>
          <Spacer h={24}/>
          <Text Text-16 centered>
            Something went wrong
          </Text>
          <Spacer.H4 />
          <Text TextThin-14 Secondary centered>
            We’re working to fix this issue, hit reload to refresh the data.
            Taking too long?
          </Text>
        </View>
        <ContactSupportTextButton Text-14/>
        <Spacer h={24}/>
        <Button hug small brandReversed title="Reload" style={styles.btn} isFetching={requesting} onPress={handleTryAgain}/>
      </View>
    </CardView>);
};
export default ConnectionFailed;
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
    },
    content: {
        alignItems: 'center',
        paddingHorizontal: rem(16),
    },
    btn: {
        width: rem(100),
    },
    img: {
        width: rem(150),
        height: rem(120),
    },
    cardView: {
        marginTop: rem(8),
    },
});
